// removed by extract-text-webpack-plugin
module.exports = {"welcome":"welcome","error":"error","loginBlock":"loginBlock"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Welcome/style.scss
// module id = 1317
// module chunks = 0